import {ITableSorting} from "@components/elements/tables/ITableSorting";
import React from "react";
import cx from "classnames";

export function Table(props: { onTableSortingChange: (e: ITableSorting) => void, sorting: { column: string; descending: boolean }, totalPages: number, onPageChange: (e: number) => void, className: string, page: number, children: React.ReactNode, loading: boolean }) {
    return (
        <div
            className={cx(
                props.className,
                "md:col-span-12",
                "col-span-12",
                "mx-3",
                "h-full",
                "overflow-auto snap-x scrollbar-thin scrollbar-track-gray-800 scrollbar-thumb-gray-400",
                "relative"
            )}
            aria-busy={props.loading}
        >
            <table className={cx("min-w-full divide-y divide-gray-200 relative")}>
                {props.children}
            </table>
        </div>
    );
}
